import { useContext, createContext } from 'react'
import { PlatformError } from '~/utils/errors'
import { PlatformConfig } from '@reward-platform/platform-config'

const PlatformConfigContext = createContext<PlatformConfig | undefined>(undefined)

export const usePlatformConfig = () => {
  const platformConfig = useContext(PlatformConfigContext)

  if (!platformConfig) {
    throw new PlatformError('usePlatformConfig must be used within PlatformConfigProvider')
  }

  return platformConfig
}

export default PlatformConfigContext
